import { Action, Dispatch } from 'redux'
import { initCheckoutAction } from 'reducks/checkout/actions'

const initOrders = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initCheckoutAction())
  }
}

export default initOrders
